import { AdminSideBarCtx } from "./AdminSideBarCtx.ts";
import { PropsWithChildren, useEffect, useState } from "react";

const SIDE_BAR_COLLAPSED_STORAGE_KEY = "checkout-admin:side-bar-collapsed";

function readStoredCollapsedPreference(): boolean {
  try {
    return localStorage.getItem(SIDE_BAR_COLLAPSED_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

function storeCollapsedPreference(isCollapsed: boolean): void {
  try {
    localStorage.setItem(SIDE_BAR_COLLAPSED_STORAGE_KEY, String(isCollapsed));
  } catch {
    return;
  }
}

export function AdminSideBarCtxProvider({ children }: PropsWithChildren) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(readStoredCollapsedPreference);

  useEffect(() => {
    storeCollapsedPreference(isCollapsed);
  }, [isCollapsed]);

  return (
    <AdminSideBarCtx.Provider
      value={{
        mobileOpen,
        openOnMobile: () => {
          setMobileOpen(true);
        },
        closeOnMobile: () => {
          setMobileOpen(false);
        },
        isCollapsed,
        toggleCollapsed: () => {
          setIsCollapsed((collapsed) => !collapsed);
        },
      }}
    >
      {children ?? null}
    </AdminSideBarCtx.Provider>
  );
}
